import styled from 'styled-components';

export default function SLPBranding({ backgroundColor, textColor }) {
	return (
		<StyledSLPBranding backgroundColor={backgroundColor} textColor={textColor}>
			Powered by&nbsp;
			<a
				href="https://sociallinkpages.com?utm_source=plugin_footer&utm_medium=link&utm_campaign=plugin"
				rel="noopener noreferrer"
				target="_blank"
			>
				<u>Social Link Pages</u> for WordPress
			</a>
		</StyledSLPBranding>
	);
}

const StyledSLPBranding = styled.div`
	background: rgb(${(props) => props.textColor || '0,0,0'}) !important;
	bottom: 0;
	color: rgb(${(props) => props.backgroundColor || '256, 256, 256'}) !important;
	font-size: 1rem !important;
	left: 0;
	opacity: 0.618;
	padding: 0.618em 0;
	position: fixed;
	text-align: center;
	width: 100%;
	z-index: 1;

	a,
	u {
		color: rgb(${(props) => props.backgroundColor || '256, 256, 256'}) !important;
	}
`;
